import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'Ultra Caddy',
  title1: 'Ultra Caddy',
  introduction_text:
    'ゴルファー向けのアプリを開発いたしました。このアプリは、ストイックなアマチュアゴルファーを対象とし、ラウンド記録と分析に特化したアプリです。弊社はユーザーインタビューからペルソナ設計、ユースケースなどを考慮した結果、アプリコンセプトを再考し、リニューアルを実施しました。',
  company: '株式会社Anchor',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'プロトタイピング・仮説検証',
  tag2src: '/cases/prototyping/',
  tag3text: 'UX/UI改善',
  tag3src: '/cases/uxui-improvement/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications',
  color: '#fff',
  background: '#222248',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/anchor.webp',
  alt: 'Ultra Caddy',
  imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = 'プロトタイピングでアプリリニューアルをご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '元々ゴルフコンペ用に作られたアプリのUIリニューアルとしてお話をいただきましたが、ユーザーインタビューからペルソナ設計やユースケースなどを考慮した結果、アプリコンセプトを再考することに。ストイックなアマチュアゴルファーを対象ペルソナとし、再度アイディエーションとプロトタイピングを行い、ラウンド記録と分析に特化したアプリにリニューアルしました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '既存アプリのUIをリニューアルしたい',
        text: '',
      },
      {
        title: 'サービス企画が明確でない',
        text: '',
      },
      {
        title: '目標はあるが、目的や手段が不明確',
        text: '',
      },
    ],
    solutions: [
      {
        title: 'UXデザインのアプローチで、現状の把握',
        text: '',
      },
      {
        title: 'アプリコンセプトの再考',
        text: '',
      },
      {
        title: 'プロジェクトの目標・目的・手段の明確化',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
